// schema.org-Daten der Firma (TravelAgency = LocalBusiness + Organization) für die Startseite.
// Kein aggregateRating: Eigenbewertungen einer Organisation auf der eigenen Seite gelten bei Google als „self-serving“ und werden im Rich-Results-Test als ungültig gemeldet.
const parseAddress = (raw) => {
  const parts = (raw || "").split(/\n|,/).map((p) => p.trim()).filter(Boolean);
  if (parts.length < 2) return raw ? { "@type": "PostalAddress", streetAddress: raw, addressCountry: "ES" } : undefined;
  const [street, zipCity, region, country] = parts;
  const m = zipCity.match(/^(\d{4,5})\s+(.+)$/);
  return {
    "@type": "PostalAddress", streetAddress: street,
    postalCode: m ? m[1] : undefined, addressLocality: m ? m[2] : zipCity,
    addressRegion: region || "Islas Canarias", addressCountry: /deutschland|germany/i.test(country || "") ? "DE" : "ES",
  };
};

export const organizationSchema = (settings, origin) => {
  const name = settings.company_name || "privateHOLIDAY";
  const logo = settings.site_logo_url || `${origin}/logo.png`;
  return {
    "@context": "https://schema.org", "@type": ["TravelAgency", "Organization"], "@id": `${origin}/#organization`,
    name, url: origin, logo, image: logo, email: settings.company_email || undefined, telephone: settings.company_phone || undefined,
    address: parseAddress(settings.company_address),
    areaServed: { "@type": "AdministrativeArea", name: "Islas Canarias" }, priceRange: "€€",
    sameAs: [settings.social_facebook, settings.social_instagram, settings.social_youtube, settings.social_pinterest, settings.social_x].filter(Boolean),
  };
};
